<template>
  <b-modal v-model="modalVisible" centered title="Itens" ok-only size="xl">
    <b-row>
      <b-col v-for="field in fields" :key="field.key" :md="field.wide ? 12 : 6">
        <b-form-group :label="field.label">
          <b-form-input :value="item[field.key]" disabled />
        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import { BModal, BRow, BCol, BFormGroup, BFormInput } from 'bootstrap-vue';

export default {
  components: { BModal, BRow, BCol, BFormGroup, BFormInput },
  data() {
    return {
      modalVisible: false,
      item: {},
      fields: [
        { key: 'sequenciaItem', label: 'SEQUÊNCIA' },
        { key: 'qtdItem', label: 'QUANTIDADE' },
        { key: 'codItem', label: 'ITEM' },
        { key: 'descrItem', label: 'DESCRIÇÃO', wide: true },
        { key: 'percDesconto', label: 'DESCONTO %' },
        { key: 'vlrUnitario', label: 'PREÇO VENDA' },
        { key: 'vlrTotalItem', label: 'TOTAL' },
      ],
    };
  },
  methods: {
    abrirModal(item) {
      this.item = item;
      this.modalVisible = true;
    },
  },
};
</script>